import type { LineItemSource } from '@/lib/services/line-items/line-items.types'

type SubscriptionCartItem = Pick<LineItemSource, 'variant_details' | 'variant'>

export const POS_SUBSCRIPTION_TERMS_CONFIRMATION_COPY =
  "I confirm I reviewed the subscription terms with the customer and received their authorization for today's order and future automatic charges at the selected frequency until they skip or cancel."

export function isSubscriptionPackageCartItem(item?: SubscriptionCartItem | null): boolean {
  const product = item?.variant_details?.product ?? item?.variant?.product ?? null

  return product?.product_catalog_type === 'subscription_package'
}

export function cartHasSubscriptionPackageItems(
  cart?: { cart_items?: readonly (SubscriptionCartItem | null | undefined)[] | null } | null
): boolean {
  return (cart?.cart_items ?? []).some(isSubscriptionPackageCartItem)
}
